import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../../../styles/main.module.scss';

const cx = classNames.bind(styles);
const RegisterSection = props => {
  const { smallCaption, leftComponent, rightComponent } = props;
  return (
    <div className={cx('register-section-layout')}>
      <div className={cx('left', smallCaption && 'small')}>{leftComponent}</div>

      <div className={cx('right')}>{rightComponent}</div>
    </div>
  );
};

RegisterSection.propTypes = {
  smallCaption: PropTypes.bool,
  leftComponent: PropTypes.node,
  rightComponent: PropTypes.node,
};

RegisterSection.defaultProps = {
  smallCaption: false,
  leftComponent: <div>Left No Content</div>,
  rightComponent: <div>Right No Content</div>,
};

export default RegisterSection;
